import request from '@/utils/request'
import { parseStrEmpty } from '@/utils/mogao'

// -------------------- /member/auth/ --------------------

// 登录
export function login(username, password, verificationCode) {
    return request({
        url: '/member/auth/login',
        method: 'post',
        data: { username, password, verificationCode }
    })
}

// 退出登录
export function logout() {
    return request({
        url: '/member/auth/logout',
        method: 'delete'
    })
}

// 获取验证码--登录
export function getVerificationCode(phone) {
    return request({
        url: '/member/auth/' + phone,
        method: 'get'
    })
}

// -------------------- /member/info/ --------------------

// 注册
export function register(data) {
    return request({
        url: '/member/info',
        method: 'post',
        data
    })
}

// 获取验证码--注册
export function getRegisterVerifyCode(phone) {
    return request({
        url: '/member/info/send/' + phone,
        method: 'get'
    })
}

// 会员模块通用短信验证码
export function getStandardVerifyCode(phone) {
    return request({
        url: '/member/info/send/standard/' + phone,
        method: 'get'
    })
}

// 获取用户详细信息
export function getUserInfo() {
    return request({
        url: '/member/info/account',
        method: 'get'
    })
}

// 查询用户列表
export function listUser(query) {
    return request({
        url: '/member/info/list',
        method: 'get',
        params: query
    })
}

// 查询用户详细
export function getUser(userId) {
    return request({
        url: '/member/info/detail/' + parseStrEmpty(userId),
        method: 'get'
    })
}

// 修改用户
export function updateUser(data) {
    return request({
        url: '/member/info/updateuser',
        method: 'put',
        data: data
    })
}

// 新增用户
export function addUser(data) {
    return request({
        url: '/member/info/adduser',
        method: 'post',
        data: data
    })
}

// 删除用户
export function delUser(id) {
    return request({
        url: '/member/info/remove/' + id,
        method: 'delete'
    })
}

// 注销账号
export function accountCancel(phone, code) {
    return request({
        url: `/member/info/cancellation?phone=${phone}&code=${code}`,
        method: 'get',
    })
}

// 修改-基本信息
export function setUserInfos(data) {
    return request({
        url: '/member/info/update',
        method: 'put',
        data
    })
}

// 修改业务联系人电话
export function resetAccountInfo(data) {
    return request({
        url: '/member/info/update/new',
        method: 'put',
        data
    })
}

// 修改账号密码
export function resetPassword(data) {
    return request({
        url: '/member/info/resetPwd',
        method: 'put',
        data
    })
}

// 查询会员基本信息
export function getBaseInfo(query) {
    return request({
        url: '/member/info/basic/info',
        method: 'put'
    })
}

// 忘记密码--提交
export function putForgetPassword(data) {
    return request({
        url: '/member/info/forgotPwd',
        method: 'put',
        data
    })
}

// 忘记密码-获取验证码
export function getForgetVerifyCode(phone) {
    return request({
        url: '/member/info/forgotPwd/send/reset/pwd/code/' + phone,
        method: 'get'
    })
}

// -------------------- /member/role/ --------------------

// 查询角色列表
export function listRole(query) {
    return request({
        url: '/member/role/list',
        method: 'get',
        params: query
    })
}

// 查询角色详细
export function getRole(roleId) {
    return request({
        url: '/member/role/' + roleId,
        method: 'get'
    })
}

// 查询角色选项
export function optionselect() {
    return request({
        url: '/member/role/optionselect',
        method: 'get'
    })
}

// 新增角色
export function addRole(data) {
    return request({
        url: '/member/role',
        method: 'post',
        data: data
    })
}

// 修改角色
export function updateRole(data) {
    return request({
        url: '/member/role',
        method: 'put',
        data: data
    })
}

// 角色数据权限
export function dataScope(data) {
    return request({
        url: '/member/role/dataScope',
        method: 'put',
        data: data
    })
}

// 角色状态修改
export function changeRoleStatus(roleId, status) {
    return request({
        url: `/member/role/${roleId}/${status}`,
        method: 'put'
    })
}

// 删除角色
export function delRole(roleId) {
    return request({
        url: '/member/role/' + roleId,
        method: 'delete'
    })
}

// 查询角色已授权用户列表
export function allocatedUserList(query) {
    return request({
        url: '/member/role/authUser/allocatedList',
        method: 'get',
        params: query
    })
}

// 查询角色未授权用户列表
export function unallocatedUserList(query) {
    return request({
        url: '/member/role/authUser/unallocatedList',
        method: 'get',
        params: query
    })
}

// 查询企业是否有管理员
export function isHaveAdminQuery() {
    return request({
        url: '/member/role/isStoreKeeper',
        method: 'get'
    })
}

// -------------------- /member/user/role/ --------------------

// 取消用户授权角色
export function authUserCancel(data) {
    return request({
        url: '/member/user/role/cancel',
        method: 'put',
        data: data
    })
}

// 批量取消用户授权角色
export function authUserCancelAll(data) {
    return request({
        url: '/member/user/role/batch/cancel',
        method: 'put',
        params: data
    })
}

// -------------------- /member/manager/ --------------------

// 授权用户选择
export function authUserSelectAll(data) {
    return request({
        url: '/member/manager/user/role/addUsers',
        method: 'put',
        params: data
    })
}

// 用户密码重置
export function resetUserPwd(accountId, newPassword) {
    const data = {
        accountId,
        newPassword
    }
    return request({
        url: '/member/manager/user/role/resetPwd',
        method: 'put',
        data: data
    })
}

// 查询用户个人信息
export function getUserProfile() {
    return request({
        url: '/member/manager/user/profile',
        method: 'get'
    })
}

// 修改用户个人信息
export function updateUserProfile(data) {
    return request({
        url: '/member/manager/user/profile',
        method: 'put',
        data: data
    })
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
    const data = {
        oldPassword,
        newPassword
    }
    return request({
        url: '/member/manager/user/profile/updatePwd',
        method: 'put',
        params: data
    })
}

// 查询授权角色
export function getAuthRole(userId) {
    return request({
        url: '/member/manager/user/role/' + userId + "/roles",
        method: 'get'
    })
}

// 保存授权角色
export function updateAuthRole(data) {
    return request({
        url: '/member/manager/user/role/addRoles',
        method: 'put',
        params: data
    })
}

// -------------------- /member/dept/ --------------------

// 查询部门下拉树结构
export function deptTreeselect() {
    return request({
        url: '/member/dept/treeselect',
        method: 'get'
    })
}

// 根据角色ID查询部门树结构
export function roleDeptTreeselect(roleId) {
    return request({
        url: '/member/dept/roleDeptTreeselect/' + roleId,
        method: 'get'
    })
}

// -------------------- /member/menu/ --------------------

// 获取会员中心菜单路由
export function getHyzxRouters() {
    return request({
        url: '/member/menu/treeinfoselect',
        method: 'get',
    })
}

// 查询菜单详细
export function getMenu(menuId) {
    return request({
        url: '/member/menu/' + menuId,
        method: 'get'
    })
}

// 查询菜单下拉树结构
export function menuTreeselect() {
    return request({
        url: '/member/menu/treeselect',
        method: 'get'
    })
}

// 根据角色ID查询菜单下拉树结构
export function roleMenuTreeselect(roleId) {
    return request({
        url: '/member/menu/roleMenuTreeselect/' + roleId,
        method: 'get'
    })
}

// 新增菜单
export function addMenu(data) {
    return request({
        url: '/member/menu',
        method: 'post',
        data: data
    })
}

// 修改菜单
export function updateMenu(data) {
    return request({
        url: '/member/menu',
        method: 'put',
        data: data
    })
}

// 删除菜单
export function delMenu(menuId) {
    return request({
        url: '/member/menu/' + menuId,
        method: 'delete'
    })
}

// -------------------- /member/enterprise/ --------------------

// 获取企业审核状态
export function firmAuditStatus() {
    return request({
        url: '/member/enterprise/check/status',
        method: 'get'
    })
}

// 企业信息
export function getFirmInfos() {
    return request({
        url: '/member/enterprise',
        method: 'get'
    })
}

// 企业信息-新增
export function addFirmInfos(data) {
    return request({
        url: '/member/enterprise/add',
        method: 'post',
        data
    })
}

// 企业信息-修改
export function setFirmInfos(data) {
    return request({
        url: '/member/enterprise/update',
        method: 'put',
        data
    })
}

// -------------------- /member/platform/ --------------------

// 企业信息-获取爱签
export function getBusinessVerification(data) {
    return request({
        url: '/member/platform/member/manage/verification',
        method: 'post',
        data
    })
}

// 获取消息列表
export function messageList(params) {
    return request({
        url: '/member/platform/member/message/single/page',
        method: 'get',
        params
    })
}

// 消息状态已读
export function messageRead(id) {
    return request({
        url: '/member/platform/member/message/read/' + id,
        method: 'get',
    })
}

// 未读消息统计
export function messageReadNmu() {
    return request({
        url: '/member/platform/member/message/count',
        method: 'get',
    })
}

// 查询会员等级
export function getMemberGrade() {
    return request({
        url: '/member/platform/member/level/detail',
        method: 'get'
    })
}

// -------------------- /member/address/ --------------------

// 地址管理-查询
export function getSiteInfos() {
    return request({
        url: '/member/address/list',
        method: 'get'
    })
}

// 地址管理-添加
export function addSiteInfos(data) {
    return request({
        url: '/member/address',
        method: 'post',
        data
    })
}

// 地址管理-修改
export function setSiteInfos(data) {
    return request({
        url: '/member/address/update',
        method: 'put',
        data
    })
}

// 地址管理-删除
export function delSiteInfos(id) {
    return request({
        url: '/member/address/' + id,
        method: 'delete'
    })
}

// -------------------- /member/right/ --------------------

// 查询会员信息
export function getMemberInfo() {
    return request({
        url: '/member/right/info/upgrade',
        method: 'get'
    })
}

// 升级会员扣除会员费用
export function deductUpgradeCost(query) {
    return request({
        url: '/member/right/info/upgrade/cost',
        method: 'get',
        params: query
    })
}

// 查询会员充值列表
export function getVipTopUpList(params) {
    return request({
        url: '/member/right/info/upgrade/page',
        method: 'get',
        params
    })
}

// -------------------- /member/info/netsign/ --------------------

// 修改签约密码
export function amendSignPassword(data) {
    return request({
        url: '/member/info/netsign/update/sign/passwd',
        method: 'post',
        data
    })
}

// 重置账号密码
export function resetSignPassword(data) {
    return request({
        url: '/member/info/netsign/reset/pwd',
        method: 'put',
        data
    })
}

// 重置签约密码-获取验证码
export function getSignVerify(data) {
    return request({
        url: '/member/info/netsign/send/reset/pwd/code',
        method: 'put',
        data
    })
}
